// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7591":"02c3ece6","7738":"40b375bc"}[chunkId] + ".chunk.css";
};